module.exports = __webpack_public_path__ + "static/media/pa.6a64fb9f.svg";